import { useQuery } from "@tanstack/react-query"
import { api } from "../lib/api"

export function usePublicNews(limit = 6) {
  return useQuery({
    queryKey: ["public-news", limit],
    queryFn: () => api.get<{ news: any[] }>("/api/public/news", { limit }),
  })
}

export function usePublicAnnouncements() {
  return useQuery({
    queryKey: ["public-announcements"],
    queryFn: () => api.get<{ announcements: any[] }>("/api/public/announcements"),
  })
}

export function usePublicCalendar() {
  return useQuery({
    queryKey: ["public-calendar"],
    queryFn: () => api.get<{ events: any[] }>("/api/public/calendar"),
  })
}

export function usePublicDownloads() {
  return useQuery({
    queryKey: ["public-downloads"],
    queryFn: () => api.get<{ downloads: any[] }>("/api/public/downloads"),
  })
}

export function useAdmissionStatus() {
  return useQuery({
    queryKey: ["admission-status"],
    queryFn: () => api.get<{ cycle: any }>("/api/public/admission-status"),
  })
}

export function usePublicFaculties() {
  return useQuery({
    queryKey: ["public-faculties"],
    queryFn: () => api.get<{ faculties: any[] }>("/api/public/faculties"),
  })
}

export function usePublicFees() {
  return useQuery({
    queryKey: ["public-fees"],
    queryFn: () => api.get<{ fees: any[] }>("/api/public/fees"),
  })
}
